import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M11.1667 2.37331V1.33331C11.1667 1.05998 10.94 0.833313 10.6667 0.833313C10.3933 0.833313 10.1667 1.05998 10.1667 1.33331V2.33331H5.83332V1.33331C5.83332 1.05998 5.60666 0.833313 5.33332 0.833313C5.05999 0.833313 4.83332 1.05998 4.83332 1.33331V2.37331C3.03332 2.53998 2.15999 3.61331 2.02666 5.20664C2.01332 5.39998 2.17332 5.55998 2.35999 5.55998H13.64C13.8333 5.55998 13.9933 5.39331 13.9733 5.20664C13.84 3.61331 12.9667 2.53998 11.1667 2.37331Z",
      fill: props.color || '#7E8695'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M13.3333 6.56C13.7 6.56 14 6.86 14 7.22666V11.3333C14 13.3333 13 14.6667 10.6667 14.6667H5.33333C3 14.6667 2 13.3333 2 11.3333V7.22666C2 6.86 2.3 6.56 2.66667 6.56H13.3333Z",
      fill: props.color || '#7E8695'
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M5.66667 10C5.49333 10 5.32 9.92668 5.19333 9.80668C5.07333 9.68001 5 9.50668 5 9.33335C5 9.16002 5.07333 8.98669 5.19333 8.86002C5.38 8.67336 5.67333 8.61334 5.92 8.72001C6.00667 8.75334 6.08 8.80002 6.14 8.86002C6.26 8.98669 6.33333 9.16002 6.33333 9.33335C6.33333 9.50668 6.26 9.68001 6.14 9.80668C6.01333 9.92668 5.84 10 5.66667 10Z",
      fill: props.color || '#7E8695'
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M8.00016 10C7.82683 10 7.6535 9.92668 7.52683 9.80668C7.40683 9.68001 7.3335 9.50668 7.3335 9.33335C7.3335 9.16002 7.40683 8.98669 7.52683 8.86002C7.58683 8.80002 7.66016 8.75334 7.74683 8.72001C7.9935 8.61334 8.28683 8.67336 8.4735 8.86002C8.5935 8.98669 8.66683 9.16002 8.66683 9.33335C8.66683 9.50668 8.5935 9.68001 8.4735 9.80668C8.44016 9.83334 8.40683 9.86001 8.3735 9.88667C8.3335 9.91334 8.2935 9.93336 8.2535 9.94669C8.2135 9.96669 8.1735 9.98002 8.1335 9.98669C8.08683 9.99336 8.04683 10 8.00016 10Z",
      fill: props.color || '#7E8695'
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M10.3332 10C10.1598 10 9.9865 9.92669 9.85984 9.80669C9.73984 9.68002 9.6665 9.50669 9.6665 9.33336C9.6665 9.16003 9.73984 8.9867 9.85984 8.86003C9.9265 8.80003 9.99317 8.75335 10.0798 8.72002C10.1998 8.66669 10.3332 8.65335 10.4665 8.68002C10.5065 8.68669 10.5465 8.70002 10.5865 8.72002C10.6265 8.73335 10.6665 8.75337 10.7065 8.78004C10.7398 8.8067 10.7732 8.83337 10.8065 8.86003C10.9265 8.9867 10.9998 9.16003 10.9998 9.33336C10.9998 9.50669 10.9265 9.68002 10.8065 9.80669C10.7732 9.83336 10.7398 9.86002 10.7065 9.88669C10.6665 9.91335 10.6265 9.93337 10.5865 9.9467C10.5465 9.9667 10.5065 9.98003 10.4665 9.9867C10.4198 9.99337 10.3732 10 10.3332 10Z",
      fill: props.color || '#7E8695'
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M5.66667 12.3333C5.58 12.3333 5.49333 12.3134 5.41333 12.28C5.32667 12.2467 5.26 12.2 5.19333 12.14C5.07333 12.0133 5 11.84 5 11.6667C5 11.4933 5.07333 11.32 5.19333 11.1933C5.26 11.1333 5.32667 11.0867 5.41333 11.0533C5.53333 11 5.66667 10.9867 5.8 11.0133C5.84 11.02 5.88 11.0333 5.92 11.0533C5.96 11.0667 6 11.0867 6.04 11.1134C6.07333 11.14 6.10667 11.1667 6.14 11.1933C6.26 11.32 6.33333 11.4933 6.33333 11.6667C6.33333 11.84 6.26 12.0133 6.14 12.14C6.10667 12.1667 6.07333 12.2 6.04 12.22C6 12.2467 5.96 12.2667 5.92 12.28C5.88 12.3 5.84 12.3133 5.8 12.32C5.75333 12.3267 5.71333 12.3333 5.66667 12.3333Z",
      fill: props.color || '#7E8695'
    }, null, 8, _hoisted_7),
    _createElementVNode("path", {
      d: "M8.00016 12.3334C7.82683 12.3334 7.6535 12.26 7.52683 12.14C7.40683 12.0134 7.3335 11.84 7.3335 11.6667C7.3335 11.4934 7.40683 11.32 7.52683 11.1934C7.7735 10.9467 8.22683 10.9467 8.4735 11.1934C8.5935 11.32 8.66683 11.4934 8.66683 11.6667C8.66683 11.84 8.5935 12.0134 8.4735 12.14C8.34683 12.26 8.1735 12.3334 8.00016 12.3334Z",
      fill: props.color || '#7E8695'
    }, null, 8, _hoisted_8),
    _createElementVNode("path", {
      d: "M10.3332 12.3334C10.1598 12.3334 9.9865 12.26 9.85984 12.14C9.73984 12.0134 9.6665 11.84 9.6665 11.6667C9.6665 11.4934 9.73984 11.32 9.85984 11.1934C10.1065 10.9467 10.5598 10.9467 10.8065 11.1934C10.9265 11.32 10.9998 11.4934 10.9998 11.6667C10.9998 11.84 10.9265 12.0134 10.8065 12.14C10.6798 12.26 10.5065 12.3334 10.3332 12.3334Z",
      fill: props.color || '#7E8695'
    }, null, 8, _hoisted_9)
  ]))
}
}

})